class LinkSider{
    def:any = {
        point:".point",
        defW:"50%",
        tranW:"80%",
        moveX:"20%",
    };
    oDiv:any;
    point:any;
    startNum:number = 0;
    nextNum:number = 1;
    maxNum:number = 0;
    canChange:boolean = true;
    constructor(name:string,obj:object){
        this.oDiv = document.querySelector(name)
        this.def = Object.assign(this.def,obj);
        this.point = $(this.oDiv).find(this.def.point);
        this.init();
    }
    init(){
        let _this = this;
        this.maxNum = $(this.oDiv).find("li").size();
        for(let i=0;i<this.maxNum;i++){
            this.point.append("<span></span>");
        }
        this.point.find("span").eq(0).addClass("on");
        this.initLi();
        this.point.find("span").click(function () {
            var index = $(this).index();
            if(!$(this).hasClass("on")){
                _this.changeLiMove(index);
            }
        })
    }
    initLi(){
        let _this = this;
        $(this.oDiv).find("li").width(this.def.defW);
        $(this.oDiv).find("li").eq(0).width("100%").css("z-index",10);
        $(this.oDiv).find("li").eq(1).width(this.def.tranW).css({
            "z-index":5,
            "marginLeft":this.def.moveX
        });
        $(this.oDiv).find("li").click(function () {
          //  console.log(1111,index);
            var index = $(this).index();
            if(index == _this.nextNum){
                _this.changeLiMove(_this.nextNum)
            }
        });
    }
    changeLiMove(next){
        let _this = this;
        if(!this.canChange){
            return false;
        }
        this.canChange = false;
        let m = this.runNextIndex(next);

        $(this.oDiv).find("li").width(this.def.defW);
        $(this.oDiv).find("li").eq(this.startNum).width("100%").css("z-index",10);
        $(this.oDiv).find("li").eq(next).width(this.def.tranW).css({
            "z-index":5,
            "marginLeft":this.def.moveX
        });
       if(this.maxNum > 2){
           $(this.oDiv).find("li").eq(m).css("z-index",2);
       }
       setTimeout(function () {
            _this.canChange = true;
           $(_this.oDiv).find("li").eq(_this.startNum).addClass("stion").css({
               "z-index":1,
               "width":_this.def.defW
           });
           $(_this.oDiv).find("li").eq(next).addClass("stion").css({
               "z-index":10,
               "marginLeft":"0%",
               "width":"100%"
           });
           $(_this.oDiv).find("li").eq(m).addClass("stion").css({
               "z-index":1,
               "marginLeft":_this.def.moveX,
               "width":_this.def.tranW
           });
           _this.startNum = next;
           _this.nextNum = m;
           $(_this.point).find("span").eq(next).addClass("on").siblings().removeClass("on");
           setTimeout(function () {
               $(_this.oDiv).find("li").removeClass("stion");
           },300)
       },10)
    }
    runNextIndex(n){
        let m = n+1;
        if(m==this.maxNum){
            m = 0;
        }
        return m;
    }
}